<template>
  <div class="filtered-search-block">
    <div class="filtered-search-wrapper">
      <div class="filtered-search-box">
        <div class="filtered-search-box-input-container">
          <div class="scroll-container">
            <ul>
              <li v-if="filters.length > 0" v-for="(filter, index) in filters" :key="index" class="filtered-search">
                <div v-if="filter.type === 'email'">
                  <div class="name">Email</div>
                  <div class="value">
                    <span>{{ filter.search }}</span>
                    <span class="clear-filter" @click="removeFilter(filter, index)"><font-awesome-icon icon="times"></font-awesome-icon></span>
                  </div>
                </div>
                <div v-if="filter.type === 'bubble'">
                  <div class="name">Bubble</div>
                  <div class="value">
                    <span>{{ filter.search }}</span>
                    <span class="clear-filter" @click="removeFilter(filter, index)"><font-awesome-icon icon="times"></font-awesome-icon></span>
                  </div>
                </div>
                <div v-if="filter.type === 'event'">
                  <div class="name">Event</div>
                  <div class="value">
                    <span>{{ filter.search }}</span>
                    <span class="clear-filter" @click="removeFilter(filter, index)"><font-awesome-icon icon="times"></font-awesome-icon></span>
                  </div>
                </div>
                <div v-if="filter.type === 'bubbleType'">
                  <div class="name">Type</div>
                  <div class="value">
                    <span>{{ filter.search }}</span>
                    <span class="clear-filter" @click="removeFilter(filter, index)"><font-awesome-icon icon="times"></font-awesome-icon></span>
                  </div>
                </div>
              </li>
              <li class="input-filter">
                <input type="text" id="filtered-search" placeholder="Search or filter results..." @click="dropdownSelected = 'global'">
              </li>
            </ul>
          </div>
          <div v-if="dropdownSelected === 'global'" id="filter-dropdown" class="filter-dropdown">
            <ul>
              <li v-if="bubble" @click="dropdownSelected = 'bubble'">
                <button>
                  <font-awesome-icon :icon="['fab', 'cloudsmith']"></font-awesome-icon>
                  <span>Bubble</span>
                </button>
              </li>
              <li v-if="event" @click="dropdownSelected = 'event'">
                <button>
                  <font-awesome-icon :icon="['fab', 'cloudsmith']"></font-awesome-icon>
                  <span>Event</span>
                </button>
              </li>
              <li v-if="bubbleType" @click="dropdownSelected = 'bubbleType'">
                <button>
                  <font-awesome-icon :icon="['fab', 'cloudsmith']"></font-awesome-icon>
                  <span>Type</span>
                </button>
              </li>
            </ul>
          </div>
          <div v-if="bubble && dropdownSelected === 'bubble'" id="filter-dropdown-bubble" class="filter-dropdown">
            <ul>
              <li v-for="bubble in bubbles" :key="bubble.id">
                <button @click="addFilter('bubble', bubble)">{{ bubble.name }}</button>
              </li>
            </ul>
          </div>
          <div v-if="event && dropdownSelected === 'event'" id="filter-dropdown-event" class="filter-dropdown">
            <ul>
              <li v-for="event in events" :key="event.id">
                <button @click="addFilter('event', event)">{{ event.alias }}</button>
              </li>
            </ul>
          </div>
          <div v-if="bubbleType && dropdownSelected === 'bubbleType'" id="filter-dropdown-bubbleType" class="filter-dropdown">
            <ul>
              <li>
                <button @click="addFilter('bubbleType', 'action')">action</button>
                <button @click="addFilter('bubbleType', 'import')">import</button>
                <button @click="addFilter('bubbleType', 'importfromintersection')">importfromintersection</button>
                <button @click="addFilter('bubbleType', 'analGeoloc')">analGeoloc</button>
              </li>
            </ul>
          </div>
        </div>
        <div class="clear-search"></div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    bubble: {
      type: Boolean,
      default: false
    },
    bubbleType: {
      type: Boolean,
      default: false
    },
    event: {
      type: Boolean,
      default: false
    },
    email: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dropdownSelected: 'none',
      filters: []
    }
  },

  computed: {
    ...mapGetters('bubbles', {
      bubbles: 'bubbles'
    }),
    ...mapGetters('events', {
      events: 'events'
    })
  },

  methods: {
    ...mapActions('events', ['loadEvents']),

    addFilter (type, obj) {
      this.dropdownSelected = 'none'
      let filter = {}

      if (type === 'bubble') {
        filter = {type: 'bubble', search: obj.name, bubble: obj}
      }

      if (type === 'event') {
        filter = {type: 'event', search: obj.alias, event: obj}
      }

      if (type === 'bubbleType') {
        filter = {type: 'bubbleType', search: obj}
      }

      this.filters.push(filter)

      this.$emit('handle', filter)
    },

    removeFilter (filter, index) {
      filter.action = 'delete'
      this.$emit('handle', filter)
      this.filters.splice(index, 1)
    }
  },

  mounted () {
    if (this.event) {
      this.loadEvents()
    }
  }
}

</script>

<style lang="scss" scoped>
  .filtered-search-block {
    background: #FAFAFA;
    padding:16px;
    margin-bottom: 12px;
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    color:#2e2e2e;

    .filtered-search-wrapper {
      .filtered-search-box {
        border: 1px solid #e5e5e5;
        background: #fff;
        display: grid;
        grid-template-columns: 1fr 40px;
        width: 100%;
        min-width: 0;

        .filtered-search-box-input-container {
          flex: 1;
          position: relative;
          min-width: 0;
          .scroll-container {
            display: flex;
            overflow-x: auto;
            white-space: nowrap;
            width: 100%;

            ul {
              display: flex;
              flex: 1;
              padding-left: 12px;
              position: relative;
              margin-bottom: 0;
              li {
                list-style: none;
                display: flex;
                flex-shrink: 0;
                margin-top: 5px;
                margin-bottom: 5px;
                &.filtered-search {
                  > div {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .name {
                      font-size: 14px;
                      display: inline-block;
                      padding: 7px;
                      background-color: #f8f8f8;
                      color: rgba(0,0,0,0.55);
                      border-radius: 2px 0 0 2px;
                      margin-right: 1px;
                      text-transform: capitalize;
                    }
                    .value {
                      font-size: 14px;
                      display: inline-block;
                      padding: 7px;
                      background-color: #f0f0f0;
                      color: rgba(0,0,0,0.85);
                      border-radius: 0 2px 2px 0;
                      margin-right: 5px;
                      padding-right: 8px;
                      .clear-filter {
                        display: inline-block;
                        padding-left: 4px;
                        padding-right: 0;
                        cursor: pointer;
                      }
                    }
                  }
                }
                &.input-filter {
                  flex:1;
                  padding: 0;
                  max-width: inherit;
                  input {
                    display: block;
                    width: 100%;
                    color: #6c757d;
                    opacity: 1;
                    position: relative;
                    min-width: 200px;
                    padding: 5px 25px 6px 0;
                    border-color: transparent;
                    font-size: 1rem;
                    line-height: 20px;
                    color: #2e2e2e;
                    background-color: #fff;
                    background-clip: padding-box;
                    height: 30px;
                  }
                }
              }
            }
          }
          .filter-dropdown {
            top: 100%;
            background: red;
            max-width: 280px;
            max-height: 312px;
            overflow: auto;
            position: absolute;
            width: auto;
            top: 100%;
            z-index: 300;
            min-width: 240px;
            margin-top: 4px;
            margin-bottom: 24px;
            font-size: 14px;
            font-weight: 400;
            padding: 8px 0;
            background-color: #fff;
            border: 1px solid #e5e5e5;
            border-radius: 3px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            ul {
              font-size: 14px;
              font-weight: 400;
              li {
                display: block;
                text-align: left;
                list-style: none;
                padding: 0 1px;
                button {
                  background: transparent;
                  border: 0;
                  border-radius: 0;
                  box-shadow: none;
                  font-weight: 400;
                  position: relative;
                  padding: 8px 16px;
                  color: #2e2e2e;
                  line-height: normal;
                  white-space: normal;
                  overflow: hidden;
                  width: 100%;
                  display: flex;
                  margin: 0;
                  text-align: left;
                  text-overflow: ellipsis;
                  cursor: pointer;

                  > svg {
                    width: 25px;
                    line-height: 1.5;
                    text-align: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/filter.vue